import { render, staticRenderFns } from "./IntegralRuleList.vue?vue&type=template&id=2707f9b1&scoped=true"
import script from "./IntegralRuleList.vue?vue&type=script&lang=js"
export * from "./IntegralRuleList.vue?vue&type=script&lang=js"
import style0 from "./IntegralRuleList.vue?vue&type=style&index=0&id=2707f9b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2707f9b1",
  null
  
)

export default component.exports